import { render, staticRenderFns } from "./init-system-modal.vue?vue&type=template&id=361f2fbd&scoped=true&"
import script from "./init-system-modal.vue?vue&type=script&lang=js&"
export * from "./init-system-modal.vue?vue&type=script&lang=js&"
import style0 from "./init-system-modal.vue?vue&type=style&index=0&id=361f2fbd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f2fbd",
  null
  
)

export default component.exports